import { Box, Menu, Tooltip } from '@mantine/core'

import { TaskType } from 'src/graphql/types/tasks'
import IconEmail from 'src/icons/IconEmail'
import IconPhone from 'src/icons/IconPhone'
import { formatSnakeValue } from 'src/lib/formatters'

import { MenuChevron, TASK_MENU_CLASSNAMES } from './taskMenuStyles'

// Same icons the tasks table uses for task type (phone for call, envelope for
// email). OTHER has no icon, matching the table.
const TypeIcon = ({ type }) => {
  if (type === TaskType.CALL) {
    return (
      <Box className="flex items-center">
        <IconPhone className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
      </Box>
    )
  }
  if (type === TaskType.EMAIL) {
    return (
      <Box className="flex items-center">
        <IconEmail className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
      </Box>
    )
  }
  return null
}

const TypeMenu = ({ type, setType }) => {
  return (
    <Menu
      offset={6}
      width={185}
      position="bottom-end"
      classNames={TASK_MENU_CLASSNAMES}
    >
      <Tooltip label={'Change type'} position="top" className="text-xs">
        <Menu.Target>
          <div
            data-testid="type-menu-trigger"
            className="flex cursor-pointer items-center gap-1 text-xs text-doubleNickel-gray-700 hover:text-doubleNickel-gray-900"
          >
            {formatSnakeValue(type)}
            <TypeIcon type={type} />
            <MenuChevron />
          </div>
        </Menu.Target>
      </Tooltip>

      <Menu.Dropdown>
        {Object.values(TaskType).map((value) => (
          <Menu.Item
            key={value}
            onClick={() => setType(value)}
            leftSection={<TypeIcon type={value} />}
          >
            {formatSnakeValue(value)}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default TypeMenu
